module.exports = __webpack_public_path__ + "img/oneDriveIconLarge.69e238a1.png";